import { Trunk } from "callable-data-objects";
import {
  getCountryName,
  getRegionFlag,
  getRegionName,
} from "Components/Shared/constants";
import SimpleListSearch from "Components/Shared/SimpleListSearch";
import { useTrunk } from "Hooks/Endpoints";
import React, { Fragment, useState } from "react";
import { Button, Flag, FlagNameValues, Table } from "semantic-ui-react";

const TrunkList = () => {
  const { trunks, select, create } = useTrunk();
  const [search, setSearch] = useState("");
  const filteredTrunks = trunks.filter(
    (t: Trunk) =>
      t.ip.indexOf(search) > -1 || t.description.indexOf(search) > -1
  );
  return (
    <Fragment>
      <SimpleListSearch
        title='Trunks'
        createText='Create Trunk'
        searchPlaceholder='Search'
        onCreate={create}
        onSearch={setSearch}
        text={search}
      />
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={4} singleLine>
              Name
            </Table.HeaderCell>
            <Table.HeaderCell width={3} singleLine>
              IPv4 Address
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Port
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Caller Format
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Called Format
            </Table.HeaderCell>
            <Table.HeaderCell width={1} singleLine>
              Country
            </Table.HeaderCell>
            <Table.HeaderCell width={1} singleLine>
              Voice Region
            </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {filteredTrunks.map((trunk: Trunk) => (
            <Table.Row>
              <Table.Cell singleLine>{trunk.description}</Table.Cell>
              <Table.Cell singleLine>{trunk.ip}</Table.Cell>
              <Table.Cell singleLine>{trunk.port}</Table.Cell>
              <Table.Cell singleLine>{trunk.callerFormat}</Table.Cell>
              <Table.Cell singleLine>{trunk.calledFormat}</Table.Cell>
              <Table.Cell singleLine>
                <Flag
                  name={
                    (trunk.countryCode?.toLowerCase() as FlagNameValues) || ""
                  }
                />
                {getCountryName(trunk.countryCode)}
              </Table.Cell>
              <Table.Cell singleLine>
                <Flag name={getRegionFlag(trunk.zone)} />
                {getRegionName(trunk.zone)}
              </Table.Cell>
              <Table.Cell textAlign='left'>
                <Button primary size='tiny' onClick={() => select(trunk.id)}>
                  View
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Fragment>
  );
};

export default TrunkList;
